<template>
  <div class="servicesModal">
    <!-- This example requires Tailwind CSS v2.0+ -->
    <div class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0 h-full">
        <!--
        Background overlay, show/hide based on modal state.

        Entering: "ease-out duration-300"
            From: "opacity-0"
            To: "opacity-100"
        Leaving: "ease-in duration-200"
            From: "opacity-100"
            To: "opacity-0"
        -->
        <div class="fixed inset-0 transition-opacity" aria-hidden="true">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <!-- This element is to trick the browser into centering the modal contents. -->
        <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        <!--
        Modal panel, show/hide based on modal state.

        Entering: "ease-out duration-300"
            From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            To: "opacity-100 translate-y-0 sm:scale-100"
        Leaving: "ease-in duration-200"
            From: "opacity-100 translate-y-0 sm:scale-100"
            To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        -->
        <div class=" mt-16 bg-white inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-xl sm:w-full sm:p-6 modal" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <div class="flex-1 px-4 flex justify-between ">
        <div class="flex-1 flex">
          <form class="w-full flex md:ml-0" action="#" method="GET">
            <label for="search_field" class="sr-only">Search</label>
            
          </form>
        </div>

        </div>

        
          <div style="height: 90%;" class="sm:flex sm:items-start overflow-scroll overflow-x-hidden flex-col">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            
              <div class="max-w-md mx-auto py-6 px-4">
                <div class="fixed top-0 w-full p-4 bg-white text-khks-red focus-within:text-gray-600">
                  <div class="absolute inset-y-0 left-0 flex items-center pointer-events-none">
                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                      <path fill-rule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clip-rule="evenodd" />
                    </svg>
                  </div>
                  <input id="search_field" class="block w-full h-full pl-8 pr-3 py-2 border-transparent text-gray-900 placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-0 focus:border-transparent sm:text-sm" placeholder="Etsi palvelua"type="text" v-model="search">
                </div>
                <div class="pt-6">
                <div class="py-1 flex cursor-pointer w-full" v-for="service in filteredList" :key="service.id._text" v-if="service.id._text" :building="service.building._text" :door="service.door._text" v-on:click="selectService(service)">
                  <span class="inline-flex items-center justify-center h-8 w-8 rounded-full bg-khks-red self-center">
                    <span class="text-sm font-medium leading-none text-white">{{ service.building._text }}</span>
                  </span>
                  <p class="text-sm font-bold text-khks-red self-center pl-4">{{ service.name._text }}</p>
                </div>
                </div>  
              </div> 
               
            </div>
            
          </div>
          <div class="flex justify-center items-center text-center bg-white w-full ">
            <button v-on:click="close()" type="button" class=" m-4 align-center justify-center inline-flex items-center px-6 py-3 border border-transparent text-base font-bold rounded-md shadow-sm text-white bg-khks-red hover:bg-khks-red-hover focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-khks-red-hover">
              TAKAISIN
            </button> 
            </div>
        </div>
        
    </div>
    </div>
  </div>
</template>

<script>

import VueLodash from 'vue-lodash'
import _ from 'lodash'

export default {
    name: "ServicesModal",
    props: {
        services: {
            type: Object,
        },
        building: String,
    },
    data() {
        return {
          servicelist : this.sortArrays(this.services.item),
          search: '',
          service: '',
        }  
    },
    methods: {
      sortArrays(arrays) { 
        return _.orderBy(arrays, 'name._text', 'asc');
      },
      selectService: function (event) {
        this.service = event;
        this.$emit('selectedServiceMethod', this.service);
        this.$emit('close');
      },
      close() {
        this.$emit('closeModal', this.building);
        this.$emit('close');
      }
    },
    computed: {
      filteredList() { 
        if (this.building !== null ) {
          return this.servicelist.filter(service => {
            if (service.building._text === this.building) {
              return service.name._text.toLowerCase().includes(this.search.toLowerCase())
            }
          })
        }
        else {
          return this.servicelist.filter(service => {
            return service.name._text.toLowerCase().includes(this.search.toLowerCase())
          })
        }
      }
    },
}   
    
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.modal {
  height: 80%;
}

::-webkit-scrollbar {
  width: 12px;
  height: 12px;
}
::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
::-webkit-scrollbar-thumb {
  background: #a82d32;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-thumb:hover {
  background: #a82d32;
}
::-webkit-scrollbar-thumb:active {
  background: #a82d32;
}
::-webkit-scrollbar-track {
  background: #d6d6d6;
  border: 0px none #ffffff;
  border-radius: 50px;
}
::-webkit-scrollbar-track:hover {
  background: #d6d6d6;
}
::-webkit-scrollbar-track:active {
  background: #d6d6d6;
}
::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
